import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useBusinessAuthContext } from "../commoncomponents/useBusinessAuthContext";
import Sidebar from "../../components/Sidebar";
import LocationsList from "./LocationsList";

const BusinessLocationsPage = () => {
  const { business } = useBusinessAuthContext();
  const navigate = useNavigate();

  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!business) {
      navigate("/business/login");
      return;
    }
    setLoading(false);
  }, [business, navigate]);

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <p>Loading locations...</p>
      </div>
    );
  }

  return (
    <div className="h-screen flex flex-row bg-background">
      <Sidebar />

      <div className="flex-1 h-auto overflow-visible py-9 transition">
        <div className="flex-1 overflow-visible py-9">
          <LocationsList />
        </div>
      </div>
    </div>
  );
};

export default BusinessLocationsPage;